var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeServings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5394 11.2065H3.93057M17.5394 11.2065C17.5394 11.2065 15.8383 14.6088 13.2867 14.6088C10.735 14.6088 10.735 14.6088 8.18334 14.6088C5.63168 14.6088 3.93057 11.2065 3.93057 11.2065M17.5394 11.2065H20.0911M3.93057 11.2065H1.37891",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0319 11.2069C16.5505 8.41725 13.7331 6.5415 10.7376 6.5415C7.74218 6.5415 4.92478 8.41725 4.44336 11.2069H7.06548C7.51714 10.0651 8.85215 9.06783 10.7376 9.06783C12.6231 9.06783 13.9581 10.0651 14.4098 11.2069H17.0319Z",
    fill: "#596475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 5.25283V2.70117",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1387 5.25283V2.70117",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7363 3.55166V1",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeServings);
export default __webpack_public_path__ + "static/media/recipe_servings.531ebc0244a2703905f7d03c9cda8ebc.svg";
export { ForwardRef as ReactComponent };